export default {
  field__account_number: 'Numer rachunku (IBAN)',
  field__document_type: 'Typ dokumentu',
  field__document_id: 'Numer dokumentu',
  field__account_holder: 'Imię i nazwisko właściciela rachunku',
  field__bank_name: 'Nazwa banku',
  field__bank_code: 'Kod banku',
  field__bank_ifsc_code: 'Kod IFSC banku',
  field__account_holder_address: 'Adres właściciela rachunku',
  field__bank_address: 'Adres banku',
  field__bic: 'BIC',
  field__purpose_of_payment: 'Tytuł płatności',
  field__pay_id: 'PayID',
  field__card_last_four_digits: 'Ostatnie cztery cyfry karty',
  field__invoice_receipt_number: 'Numer faktury/paragonu',
  field__rif: 'RIF',
  field__phone: 'Telefon',
  field__beneficiary: 'Beneficjent',
  field__cbu: 'CBU/CVU',
  field__alias: 'Alias',
};
